import React, { forwardRef } from 'react';
import { ContentSuggestionValue } from './ContentSuggestionValue';
import './ContentSuggestion.scss';
import Suggestion from '../suggestion/Suggestion';
import ContentSuggestionLabel from './ContentSuggestionLabel';

type Props = Readonly<{
  id?: string;
  value: ContentSuggestionValue;
  ariaSelected?: boolean;
  ariaDescribedBy?: string;
  tabIndex?: number;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  onClick?: () => void;
}>;

const ContentSuggestion = forwardRef<HTMLAnchorElement, Props>(
  (
    {
      id,
      value,
      ariaSelected = false,
      ariaDescribedBy,
      tabIndex = -1,
      onKeyDown,
      onClick,
    },
    ref,
  ) => (
    <Suggestion
      ref={ref}
      id={id}
      href={value.treeElement.href}
      ariaSelected={ariaSelected}
      ariaDescribedBy={ariaDescribedBy}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
      onClick={onClick}>
      <ContentSuggestionLabel
        treeElement={value.treeElement}
        treeElementParent={value.treeElementParent}
      />
    </Suggestion>
  ),
);

export default ContentSuggestion;
